import { createTheme } from '@material-ui/core/styles';
import overrides from '../override';
import {
  colors,
  fonts,
  headerFont,
  subTitle,
  titleLabel,
  formlabelFont,
  buttonFont,
  checkboxFont,
  inputFont,
  addbuttonFont,
  companyDataFont,
  filterFont,
  iftaReport,
  inspectionInput,
  inspectionresolution,
} from './variables';
import { IS_ADMIN } from '../../constants/validation';
import parentTheme from '../';

const defaultTheme = createTheme();

const theme = createTheme({
  ...parentTheme({
    colors,
    fonts,
    headerFont,
    subTitle,
    titleLabel,
    formlabelFont,
    buttonFont,
    checkboxFont,
    inputFont,
    addbuttonFont,
    companyDataFont,
    filterFont,
    iftaReport,
    inspectionInput,
    inspectionresolution,
  }),

  ...(IS_ADMIN
    ? {
        palette: {
          primary: {
            main: colors.PRIMARY_MAIN,
            contrastText: colors.PRIMARY_CONTRAST,
            border: colors.PRIMARY_BORDER,
          },
          secondary: {
            main: colors.SECONDARY_MAIN,
            contrastText: colors.WHITE,
          },
          grey: { color: colors.DAILY_LOG_GRAPH_BORDER },
          background: {
            default: colors.PRIMARY_MAIN,
          },
          error: {
            main: colors.RED,
          },
          warning: {
            main: colors.WARNING,
          },
          leftMenuText: {
            color: colors.PRIMARY_CONTRAST,
            fontSize: '16px',
            textDecoration: 'none',
            paddingTop: '2px',
          },
          fontFamily: fonts,
          bodyFontSize: '16px',
          bodySmallFontSize: '16px',
          backgroundColor: '#fff',
          contentStyle: {
            minHeight: '100vh',
            padding: '0% 3% 3% 3%',
            backgroundColor: colors.PRIMARY_MAIN,
          },
          contentlogsStyle: {
            minHeight: '100vh',
            padding: '0',
            paddingTop: '2%',
            backgroundColor: colors.PRIMARY_MAIN,
          },
        },
        themeConfig: {
          NO_INPUT_BORDER: true,
        },
        colors: { ...colors },
        overrides: {
          ...overrides,
          MuiExpansionPanelDetails: {
            root: {
              padding: '16px 16px 0px 16px',
            },
          },
          MuiButtonBase: {
            root: {
              disabled: true,
            },
          },
          MuiTableSortLabel: {
            root: {
              color: colors.SECONDARY_MAIN + ' !important',
              '&:hover': {
                color: colors.SECONDARY_MAIN + ' !important',
              },
            },
            iconDirectionDesc: {},
            active: {
              color: colors.SECONDARY_MAIN + ' !important',
            },
            icon: {
              color: colors.SECONDARY_MAIN + ' !important',
            },
          },
          MuiTableRow: {
            root: {
              backgroundColor: colors.BACKGROUND,
              color: colors.PRIMARY_CONTRAST,
              '&:hover': {
                backgroundColor: colors.BACKGROUND,
              },
            },
          },
          MuiSvgIcon: { root: { fontSize: '145.5%' } },
          MuiTable: {
            root: {
              border: '1px solid ' + colors.PRIMARY_BORDER,
            },
          },
          MuiTypography: {
            body1: {
              color: colors.PRIMARY_CONTRAST,
              fontSize: '16px',
            },
          },
          MuiPaper: {
            root: {
              backgroundColor: 'none',
            },
          },
          MuiInput: {
            root: {
              width: '100%',
              color: colors.PRIMARY_CONTRAST,
              height: '40px',
              borderRadius: '3px',
              backgroundColor: colors.PRIMARY_MAIN + '!important',
              fontSize: '16px',
              marginBottom: '8px',
            },
          },
          MuiInputBase: {
            input: {
              color: colors.PRIMARY_CONTRAST,
              border: '1px solid ' + 'rgba(255, 255, 255, 0.3)' + '!important',
              backgroundColor: colors.PRIMARY_MAIN + '!important',
              '&::placeholder': {
                fontSize: '16px',
                opacity: '0.5',
                fontWeight: '400',
              },
              '&:active': {
                border: '1px solid' + colors.SECONDARY_MAIN + '!important',
                borderRadius: '3px',
              },
              '&:focus': {
                border: '1px solid' + colors.SECONDARY_MAIN + '!important',
                borderRadius: '3px',
              },
            },
          },
          MuiTableCell: {
            head: {
              color: colors.WHITE,
            },
            paddingCheckbox: {
              color: colors.PRIMARY_MAIN + ' !important',
            },
            body: {
              backgroundColor: colors.BLACK,
              color: colors.PRIMARY_CONTRAST,
              borderBottom: '.5px solid ' + colors.PRIMARY_MAIN,
              fontSize: '18px',
            },
          },
          MuiIconButton: {
            root: {
              color: colors.SECONDARY_MAIN,
            },
          },
          MuiButton: {
            root: {
              color: colors.WHITE,
              backgroundColor: colors.SECONDARY_MAIN,
              // padding: '0px!important'
            },
          },
        },
        breakpoints: {
          values: {
            xs: 0,
            xsm: 320,
            sm: 450,
            smd: 481,
            md: 768,
            mlg: 960,
            lg: 1024,
            xl: 1280,
            xxl: 1366,
          },
        },

        typography: {
          body1: {
            color: colors.PRIMARY_CONTRAST,
            fontSize: '16px',
            textTransform: 'none',
          },
          body2: {
            fontSize: '16px',
          },
          h1: {
            fontSize: '22px',
            color: colors.PRIMARY_CONTRAST,
            [defaultTheme.breakpoints.up('sm')]: {
              fontSize: '26px',
            },
          },
          h2: {
            fontSize: '20px',
            color: colors.SECONDARY_MAIN,
            [defaultTheme.breakpoints.up('sm')]: {
              fontSize: '24px',
            },
          },
          backgroundColor: colors.PRIMARY_MAIN,
          fontFamily: fonts,
          color: colors.PRIMARY_CONTRAST,
          subtitle1: {
            fontSize: '18px',
            [defaultTheme.breakpoints.between('sm', 'md')]: {
              fontSize: '20px',
            },
            [defaultTheme.breakpoints.up('lg')]: {
              fontSize: '27px',
            },
          },
        },
      }
    : {}),

  ...(IS_ADMIN
    ? {}
    : {
        ...parentTheme({
          colors,
          fonts,
          headerFont,
          subTitle,
          titleLabel,
          formlabelFont,
          buttonFont,
          checkboxFont,
          inputFont,
          addbuttonFont,
          companyDataFont,
          filterFont,
          iftaReport,
          inspectionInput,
          inspectionresolution,
        }),
        palette: {
          ...parentTheme({
            colors,
            fonts,
            headerFont,
            subTitle,
            titleLabel,
            formlabelFont,
            buttonFont,
            checkboxFont,
            inputFont,
            addbuttonFont,
            companyDataFont,
            filterFont,
            iftaReport,
            inspectionInput,
            inspectionresolution,
          }).palette,
          contentStyle: {
            minHeight: 'calc(100vh - 181px)',
            padding: '0',
            backgroundColor: colors.BODY_BACKGROUND,
          },
          contentlogsStyle: {
            minHeight: 'calc(100vh - 181px)',
            padding: '0',
            backgroundColor: colors.BODY_BACKGROUND,
          },
          footerTheme: {
            flexDirection: 'column',
            minHeight: '130px',
            height: 'auto',
            justifyContent: 'flex-start',
          },
          footerPadding: {
            paddingLeft: '0',
            padding: '20px 0',
            marginTop: '0',
          },
          footerAlign: {
            paddingRight: '10px',
            textAlign: 'left',
          },
          footerWidth: {
            justifyContent: 'center',
            width: '100%',
            fontSize: '16px',
          },
          oldLogo: {
            width: '150px',
          },
        },
      }),
});

export default theme;
